import {Component, Input, OnInit} from '@angular/core';
import {BoardProject} from '../../../../../class/lifeproject/board-project';
import {BaseResultComponent} from '../../../base-result/base-result.component';
import {NbWindowService} from '@nebular/theme';

@Component({
    selector: 'app-board-view',
    templateUrl: './board-view.component.html',
    styleUrls: ['./board-view.component.css']
})
export class BoardViewComponent extends BaseResultComponent implements OnInit {

    @Input()
    boardProject: BoardProject;

    total = 0;

    constructor(windowService: NbWindowService) {
        super(windowService);
    }

    onResultImpl(): void {
        super.onResultImpl();
        this.total = 0;
    }
}
